// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/system';
import { useFileRowSelection } from '../useFileRowSelection';
import stylesDef from './styles';

interface ComponentProps {
  kind: FileSelectionKind;
  id: string;
  bounds: [number, number, number, number] | null;
  orderedIds: string[];
  rowSx: object;
  children: React.ReactNode;
}

// Wraps an existing file row with the D50 gestures: hover focuses the file's
// map footprint, click toggles the shared selection (shift = D59 ranges),
// double-click zooms. Row-internal buttons must stopPropagation; dialogs and
// popovers belong OUTSIDE this wrapper - portals bubble through the React
// tree, so a dialog click inside would toggle the row.
export const SelectableFileRow: React.FC<ComponentProps> = ({
  kind, id, bounds, orderedIds, rowSx, children,
}) => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const {
    selected, hoveredFromMap, rowRef, onClick, onMouseEnter, onMouseLeave, onDoubleClick,
  } = useFileRowSelection(kind, id, bounds, orderedIds);

  return (
    <Box
      ref={rowRef}
      sx={[rowSx, styles.row, hoveredFromMap && styles.rowHovered, selected && styles.rowSelected]}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onDoubleClick={onDoubleClick}
    >
      {children}
    </Box>
  );
};

export default SelectableFileRow;
